import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Campaign } from '../models/campaign.model';
import { CampaniasService } from '../services/campanias.service';
import { SpinnerService } from '../services/spinner.service';

@Component({
  selector: 'app-campaign-detail',
  templateUrl: './campaign-detail.component.html',
  styleUrls: ['./campaign-detail.component.scss']
})
export class CampaignDetailComponent implements OnInit {

  public idCampania;
  public campaign;
  public documentDescription = 'Mas información sobre la campaña';
  public documentIcon = 'http://fundacion.bcr.com.ar/imagenes/documento/documento.png';

  constructor(
    private campaniaService: CampaniasService,
    private route: ActivatedRoute,
    private spinnerService: SpinnerService,
  ) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.idCampania = +params['idCampania'];
      this.getById(this.idCampania);
    })
  }

  getById(id: number) {
    this.spinnerService.updatedState(true);
    this.campaniaService.getById(id).subscribe(
      (data: Campaign) => {
        console.log(data);
        this.spinnerService.updatedState(false);
        this.campaign = data;
        console.log(this.campaign);
      },
      (err) => {
        this.spinnerService.updatedState(false);
        console.log(err);
      }
    );
  }


}
